import { getString } from "../../common/common";

export const MI_ITIN = "MI_ITIN";
export const MI_FINANCIAL_PERFORMANCE = "MI_FINANCIAL_PERFORMANCE";
export const MI_MANAGEMENT = "MI_MANAGEMENT";
export const MI_RTI_ACT = "MI_RTI_ACT";
export const MI_AWARDS = "MI_AWARDS";
export const MI_GST = "MI_GST";
export const MI_KNOW_MORE = "MI_KNOW_MORE";

export const MI_SAKALA_SERVICES = "MI_SAKALA_SERVICES";
export const MI_STUDENT_PASS = "MI_STUDENT_PASS";
export const MI_WBFP = "MI_WBFP";
export const MI_SUTP_ITS = "MI_SUTP_ITS";
export const MI_MORTH_PROJECT = "MI_MORTH_PROJECT";
export const MI_MORTH_VTMS_PIS = "MI_MORTH_VTMS_PIS";
export const MI_PROJECT = "MI_PROJECT";
export const MI_HIRE_BUS = "MI_HIRE_BUS";
export const MI_CASULA_CONTACT = "MI_CASULA_CONTACT";

export const MI_NEW_FRANCHISEE = "MI_NEW_FRANCHISEE";
export const MI_GENERAL_INFO = "MI_GENERAL_INFO";

export const translations = {
  en: {
    [MI_ITIN]: "IT in KSRTC",
    [MI_FINANCIAL_PERFORMANCE]: "Financial Performance",
    [MI_MANAGEMENT]: "Management",
    [MI_RTI_ACT]: "RTI Act",
    [MI_AWARDS]: "Awards",
    [MI_GST]: "GST",
    [MI_KNOW_MORE]: "Know More About",

    [MI_SAKALA_SERVICES]: "SAKALA Services",
    [MI_STUDENT_PASS]: "Student Pass",
    [MI_WBFP]: "World Bank Funded Project",
    [MI_SUTP_ITS]: "SUTP-ITS",
    [MI_MORTH_PROJECT]: "MoRTH Assisted Project",
    [MI_MORTH_VTMS_PIS]: "MoRTH Assisted VTMS-PIS",
    [MI_PROJECT]: "Project",
    [MI_HIRE_BUS]: "Hire a Bus",
    [MI_CASULA_CONTACT]: "Casual Contact",

    [MI_NEW_FRANCHISEE]: "New Franchisee Procedure",
    [MI_GENERAL_INFO]: "General Information",
  },
  kn: {
    [MI_ITIN]: "KSRTC ಯಲ್ಲಿ ಐ.ಟಿ",
    [MI_FINANCIAL_PERFORMANCE]: "ಹಣಕಾಸಿನ ಕಾರ್ಯಕ್ಷಮತೆ",
    [MI_MANAGEMENT]: "ನಿರ್ವಹಣೆ",
    [MI_RTI_ACT]: "RTI ಕಾಯಿದೆ",
    [MI_AWARDS]: "ಪ್ರಶಸ್ತಿಗಳು",
    [MI_GST]: "ಜಿ ಎಸ್ ಟಿ",
    [MI_KNOW_MORE]: "ಬಗ್ಗೆ ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",

    [MI_SAKALA_SERVICES]: "ಸಕಲ ಸೇವೆಗಳು",
    [MI_STUDENT_PASS]: "ವಿದ್ಯಾರ್ಥಿ ಪಾಸ್",
    [MI_WBFP]: "ವಿಶ್ವ ಬ್ಯಾಂಕ್ ಅನುದಾನಿತ ಯೋಜನೆ",
    [MI_SUTP_ITS]: "SUTP-ITS",
    [MI_MORTH_PROJECT]:
      "MoRTHರ(ಸ್ತೆ ಸಾರಿಗೆ ಮತ್ತು ಹೆದ್ದಾರಿಗಳ ಸಚಿವಾಲಯ) ನೆರವಿನ ಯೋಜನೆ",
    [MI_MORTH_VTMS_PIS]:
      "MoRTH(ರಸ್ತೆ ಸಾರಿಗೆ ಮತ್ತು ಹೆದ್ದಾರಿಗಳ ಸಚಿವಾಲಯ) ನೆರವಿನ VTMS-PIS",
    [MI_PROJECT]: "ಯೋಜನೆ",
    [MI_HIRE_BUS]: "ಬಸ್ ಅನ್ನು ಬಾಡಿಗೆಗೆ ನೀಡಿ",
    [MI_CASULA_CONTACT]: "ಸಾಂದರ್ಭಿಕ ಸಂಪರ್ಕ",

    [MI_NEW_FRANCHISEE]: "ಹೊಸ ಫ್ರಾಂಚೈಸಿ ಕಾರ್ಯವಿಧಾನ",
    [MI_GENERAL_INFO]: "ಸಾಮಾನ್ಯ ಮಾಹಿತಿ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
